import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { Text } from '@metaicg/sensei-ui';
import styles from '@/shared/components/avatar/styles';

const AvatarContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['clickable'].includes(prop),
})<Pick<AvatarProps, 'clickable' | 'onClick'>>(styles);

export type AvatarProps = {
  src?: string | null;
  alt: string;
  onClick?: () => void;
  clickable?: boolean;
};

const Avatar: FC<AvatarProps> = ({ src, alt, onClick, clickable }) => {
  const [hasError, setHasError] = useState(false);
  let altFirstChar = alt.charAt(0).toUpperCase();
  let content =
    src && !hasError ? (
      <img src={src} alt={alt} aria-label="avatar-image" draggable={false} onError={() => setHasError(true)} />
    ) : (
      <Text size="title" weight="medium" color="neutral.palette300">
        {altFirstChar}
      </Text>
    );

  return (
    <AvatarContainer
      onClick={onClick}
      aria-label={alt}
      tabIndex={onClick || clickable ? 0 : undefined}
      role={onClick || clickable ? 'button' : 'img'}
      aria-labelledby="avatar-label"
      clickable={clickable}
    >
      {content}
    </AvatarContainer>
  );
};

export default Avatar;
